// Local inline SVG icon set — replaces Material Symbols.  Each icon is a function
// component so consumers control sizing/colour via currentColor.

const baseProps = (size = 20) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
});

export function IconDashboard(p) {
  return (
    <svg {...baseProps(p.size)}>
      <rect x="3" y="3" width="7" height="9" rx="1.6" />
      <rect x="14" y="3" width="7" height="5" rx="1.6" />
      <rect x="14" y="12" width="7" height="9" rx="1.6" />
      <rect x="3" y="16" width="7" height="5" rx="1.6" />
    </svg>
  );
}
export function IconDelivery(p) {
  return (
    <svg {...baseProps(p.size)}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M8 9v6M12 9v6M16 9v6" />
    </svg>
  );
}
export function IconRoadmap(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M3 7h14a4 4 0 0 1 0 8H7a4 4 0 0 0 0 8h14" />
      <circle cx="3" cy="7" r="1.4" fill="currentColor" />
      <circle cx="21" cy="23" r="1.4" fill="currentColor" />
    </svg>
  );
}
export function IconFinance(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M4 20h16M6 16V8M10 16V4M14 16V10M18 16V6" />
    </svg>
  );
}
export function IconLifecycle(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M21 12a9 9 0 1 1-3.5-7.1" />
      <path d="M21 4v5h-5" />
    </svg>
  );
}
export function IconGate(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M4 4v16M20 4v16" />
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  );
}
export function IconAI(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.5 5.5l2 2M16.5 16.5l2 2M5.5 18.5l2-2M16.5 7.5l2-2" />
      <circle cx="12" cy="12" r="4" />
    </svg>
  );
}
export function IconConnector(p) {
  return (
    <svg {...baseProps(p.size)}>
      <rect x="3" y="7" width="6" height="10" rx="1" />
      <rect x="15" y="7" width="6" height="10" rx="1" />
      <path d="M9 12h6" />
    </svg>
  );
}
export function IconLineage(p) {
  return (
    <svg {...baseProps(p.size)}>
      <circle cx="5" cy="6" r="2" />
      <circle cx="19" cy="12" r="2" />
      <circle cx="5" cy="18" r="2" />
      <path d="M7 6h6a4 4 0 0 1 4 4v2M7 18h6a4 4 0 0 0 4-4v-2" />
    </svg>
  );
}
export function IconUsers(p) {
  return (
    <svg {...baseProps(p.size)}>
      <circle cx="9" cy="9" r="3.4" />
      <path d="M3 19c1.2-3.5 4-5 6-5s4.8 1.5 6 5" />
      <circle cx="17" cy="7" r="2.4" />
      <path d="M15 13.5c2 .4 3.4 1.6 4 3.5" />
    </svg>
  );
}
export function IconShield(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M12 3l8 3v6c0 4.5-3.1 8.5-8 9-4.9-.5-8-4.5-8-9V6l8-3z" />
      <path d="M9.5 12.5l2 2 3.5-4" />
    </svg>
  );
}
export function IconBell(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M6 16V11a6 6 0 1 1 12 0v5l1.5 2H4.5z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </svg>
  );
}
export function IconSearch(p) {
  return (
    <svg {...baseProps(p.size)}>
      <circle cx="11" cy="11" r="6" />
      <path d="M20 20l-3.5-3.5" />
    </svg>
  );
}
export function IconChevron(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}
export function IconClose(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}
export function IconCheck(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M5 12l5 5L20 7" />
    </svg>
  );
}
export function IconAlert(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M12 4l10 17H2L12 4z" />
      <path d="M12 10v5M12 18v.5" />
    </svg>
  );
}
export function IconSparkles(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M12 3l1.7 4.5L18 9l-4.3 1.5L12 15l-1.7-4.5L6 9l4.3-1.5L12 3z" />
      <path d="M18 14l.8 2L21 17l-2.2 1-.8 2-.8-2L15 17l2.2-1z" />
    </svg>
  );
}
export function IconHome(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M3 11l9-8 9 8v9a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1z" />
    </svg>
  );
}
export function IconDoc(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M7 3h7l5 5v13H7z" />
      <path d="M14 3v5h5" />
    </svg>
  );
}
export function IconExport(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M12 3v12M7 8l5-5 5 5" />
      <path d="M5 21h14" />
    </svg>
  );
}
export function IconTarget(p) {
  return (
    <svg {...baseProps(p.size)}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" />
    </svg>
  );
}
export function IconBriefcase(p) {
  return (
    <svg {...baseProps(p.size)}>
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
      <path d="M3 13h18" />
    </svg>
  );
}
export function IconKanban(p) {
  return (
    <svg {...baseProps(p.size)}>
      <rect x="3" y="4" width="5" height="16" rx="1" />
      <rect x="10" y="4" width="5" height="11" rx="1" />
      <rect x="17" y="4" width="4" height="7" rx="1" />
    </svg>
  );
}
export function IconBranch(p) {
  return (
    <svg {...baseProps(p.size)}>
      <circle cx="6" cy="5" r="2" />
      <circle cx="6" cy="19" r="2" />
      <circle cx="18" cy="12" r="2" />
      <path d="M6 7v10" />
      <path d="M6 12h6a4 4 0 0 0 4-4" />
    </svg>
  );
}
export function IconChat(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M4 5h16v11H9l-5 4z" />
      <path d="M8 10h8M8 13h5" />
    </svg>
  );
}
export function IconKey(p) {
  return (
    <svg {...baseProps(p.size)}>
      <circle cx="8" cy="14" r="4" />
      <path d="M11 12l9-9 2 2-3 3 2 2-2 2-2-2-3 3" />
    </svg>
  );
}
export function IconClipboard(p) {
  return (
    <svg {...baseProps(p.size)}>
      <rect x="5" y="4" width="14" height="17" rx="2" />
      <path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1" />
      <path d="M9 11h6M9 15h6M9 19h4" />
    </svg>
  );
}
export function IconBookmark(p) {
  return (
    <svg {...baseProps(p.size)}>
      <path d="M6 3h12v18l-6-4-6 4z" />
    </svg>
  );
}
export function IconBinoculars(p) {
  return (
    <svg {...baseProps(p.size)}>
      <circle cx="6.5" cy="15" r="3.5" />
      <circle cx="17.5" cy="15" r="3.5" />
      <path d="M10 15v-4l-1-5h-2L5 12M14 15v-4l1-5h2l2 6M10 11h4" />
    </svg>
  );
}
